import i18n from "i18next";
import { faPaperclip } from "@fortawesome/pro-regular-svg-icons";
import { AavoObjectTypeApi } from "src/api/generated/common/sourceType/aavoObjectTypeApi.ts";
import { DocumentsOfObjectView } from "./DocumentsOfObjectView.tsx";
import { AsyncButton, AsyncButtonProps } from "../../../common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "../../../common/dialogs/useGenericDialog.ts";
import { AavoObjectRef } from "src/api/generated/common/sourceType/aavoObjectRef.ts";

export interface DocumentsOfObjectButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	objectRef: AavoObjectRef | undefined;
	editable?: boolean
}

export const DocumentsOfObjectButton = ({
	objectRef,
	label = "",
	editable,
	...other
}: DocumentsOfObjectButtonProps) => {
	const { openDialog } = useGenericDialog();

	return (
		<AsyncButton
			label={label}
			icon={faPaperclip}
			disabled={!objectRef}
			tooltip={i18n.t("connected_documents")}
			color={"primary"}
			onClick={async () => {
				if (!objectRef) return;

				const description = await AavoObjectTypeApi.getAavoObjectDescription({
					objectRef: objectRef,
				});

				openDialog(() => ({
					title: `${i18n.t("connected_documents")} (${description})`,
					children: <DocumentsOfObjectView objectRef={objectRef} editable={editable} />,
				}));
			}}
			{...other}
		/>
	);
};
